import React from 'react';
import PickupRequestReport from './PickupRequestReport';

const ClientPickupRequestReport = () => (
  <PickupRequestReport requestType="CLIENT" title="Client Pickup Request Report" />
);

export default ClientPickupRequestReport;
